import doelgerTheme from 'typography-theme-doelger'

import { TypographyOptions } from './types.js'

export const typography: TypographyOptions = {
  /**
   * @tag Vite migration
   * 'typography-theme-doelger' module provides a default export and breaks Rollup ESM-CJS interop
   * https://github.com/vitejs/vite/issues/2139#issuecomment-1024852072
   */
  ...(doelgerTheme.default ? doelgerTheme.default : doelgerTheme),
  baseFontSize: '16px',
}
